module.exports = "/packs/004-be8c6d22bcf89400a2e85f6576a86533.jpg";